import React from 'react';
import {theme} from '../../src/themes/default-theme';
import styled from '@emotion/styled';

const Container = styled.div`
  font-family: 'Open Sans';
  text-align: center;
`

const Header = styled.div`
  padding: 12px;
`

const Unsupported  = styled.div`
  padding: 87px 15px;
  font-family: 'Open Sans';
  color: white;
  text-align: center;
  background: rgb(63,184,255);
  background: -moz-linear-gradient(270deg, rgba(63,184,255,1) 0%, rgba(1,112,212,1) 100%);
  background: -webkit-linear-gradient(270deg, rgba(63,184,255,1) 0%, rgba(1,112,212,1) 100%);
  background: linear-gradient(270deg, rgba(63,184,255,1) 0%, rgba(1,112,212,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#3fb8ff",endColorstr="#0170d4",GradientType=1);
  
  h5 {
    font-size: 18px;
    ${theme.breakpoints.up('lg')} {
      font-size: 24px;
    }
  }
 
`


const HeaderContainer = styled.div`
  
`

const Logo = styled.img`
  margin: 0 auto;
  width: 90px;
  height: auto;
  display: block;
`

const Topo = styled.div `
  background-image: url('/images/update-browser/unsupported-topo.png');
  height: 60px;
`

const Download = styled.div `
  padding: 30px 15px 50px;
  color: #758094;
  font-size: 16px;

  a {
    color: #0170D4;
    text-decoration: none;
  }

  ${theme.breakpoints.up('lg')} {
    padding: 73px 15px 100px;
  }

  table {
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    margin-bottom: 38px;

    td {
      padding: 0 10px;
      max-width: 120px;
      width: 33.333333%;

      ${theme.breakpoints.up('md')} {
        padding: 0 20px;
      }

      img {
        width: 100%;
        height: auto;
        border: none;
      }
    }
  }
`

const Footer = styled.div`
  background-color: ${theme.palette.charcoal};
  padding: 30px 15px;
  color: white;
`

const SocialLinks = styled.div`
  table {
    margin-left: auto;
    margin-right: auto;

    td {
      padding: 0 7px;

      img {
        border: none;
      }
    }
  }
`

const Copy = styled.div`
  text-align: center;

  p {
    margin: 10px 0 0;
  }
`

const UpdateBrowser = (props) => {

  return (
    <Container>

      <Header>
        <HeaderContainer>
          <Logo src="/images/logo.png" alt="Jayco" />
        </HeaderContainer>
      </Header>
      <Unsupported>
        <h5>This website does not support the web browser you are using.<br />Please upgrade to a more recent and secure version.</h5>
      </Unsupported>
      <Topo />
      <Download>
        <p>You can download a more up to date and secure browser from:</p>
        <table>
          <tbody>
            <tr>
              <td>
                <a href="https://www.google.com.au/chrome/" target="_blank">
                  <img src="/images/update-browser/unsupported-chrome.png" alt="Chrome" width="120" height="143" />
                </a>
              </td>
              <td>
                <a href="https://www.microsoft.com/en-us/edge" target="_blank">
                  <img src="/images/update-browser/unsupported-firefox.png" alt="Firefox" width="120" height="143" />
                </a>
              </td>
              <td>
                <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">
                  <img src="/images/update-browser/unsupported-edge.png" alt="Edge" width="120" height="143" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <p>If you are still experiencing difficulties using our site please contact us at <a href="mailto:info@jayco.com.au" id="mail">info@jayco.com.au</a></p>
      </Download>
      <Footer>
        <SocialLinks>
          <table>
            <tbody>
              <tr>
                <td>
                  <a href="https://www.facebook.com/JaycoAust/" target="_blank">
                    <img src="/images/update-browser/icons/facebook.png" alt="Instagram" width="11" height="20" />
                  </a>
                </td>
                <td>
                  <a href="https://www.instagram.com/jaycoaustralia/" target="_blank">
                    <img src="/images/update-browser/icons/instagram.png" alt="Instagram" width="20" height="20" />
                  </a>
                </td>
                <td>
                  <a href="https://www.youtube.com/jaycoaustraliaofficial/" target="_blank">
                    <img src="/images/update-browser/icons/youtube.png" alt="Youtube" width="20" height="20" />
                  </a>
                </td>
                <td>
                  <a href="https://www.linkedin.com/company/jayco-australia/" target="_blank">
                    <img src="/images/update-browser/icons/linkedin.png" alt="Linkedin" width="20" height="20" />
                  </a>
                </td>
                {/* <td>
                  <a href="#" target="_blank">
                    <img src="/images/update-browser/icons/twitter.png" alt="twitter" width="20" height="20" />
                  </a>
                </td> */}
              </tr>
            </tbody>
          </table>
        </SocialLinks>
        <Copy>
          <p>Jayco Australia</p>
        </Copy>
      </Footer>
  
    </Container>
  )
}
  
export default UpdateBrowser